export default __webpack_public_path__ + "static/main-video-mobile-7d00eab28ca35ddee855a01abcf353d6.mp4";